import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  AlertTitle,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LoginIcon from "@mui/icons-material/Login";

function GhostLoginConfirmBox({ open, setOpen, selectedUser, onConfirm }) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm(selectedUser.id);
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 1,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          color: "warning.main",
        }}
      >
        <WarningAmberIcon fontSize="large" />
        <Typography variant="h6" fontWeight="bold">
          Ghost Login Confirmation
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          <AlertTitle sx={{ fontWeight: "bold" }}>Security Notice</AlertTitle>
          This action will be logged and audited. Only use ghost login for
          legitimate support or debugging purposes.
        </Alert>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" gutterBottom>
            You are about to login as:
          </Typography>

          <Box
            sx={{
              bgcolor: "grey.100",
              p: 2,
              borderRadius: 2,
              mt: 1,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              <strong>User ID:</strong> {selectedUser?.id}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Username:</strong> {selectedUser?.username}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Email:</strong> {selectedUser?.email}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <strong>Type:</strong>{" "}
              {selectedUser?.is_creator
                ? "Creator"
                : selectedUser?.is_promouser
                ? "Promo User"
                : selectedUser?.is_creator_client
                ? "Creator Client"
                : "User"}
            </Typography>
          </Box>
        </Box>

        <Typography variant="body2" color="text.secondary">
          Your current session will be replaced with this user's session. You
          can logout to return to your superuser account.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="inherit"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="warning"
          startIcon={<LoginIcon />}
          sx={{ textTransform: "none" }}
        >
          Confirm Ghost Login
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GhostLoginConfirmBox;
